export const getListSearchResults = state => state.entities.listSearch.results || [];
export const isListSearchLoading = state => state.entities.listSearch.isLoading;
export const getListSearchError = state => state.entities.listSearch.error || null;
